import { RemixBrowser } from '@remix-run/react'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { z } from 'zod'
import { customErrorMap } from './utils/zod'

z.setErrorMap(customErrorMap)

if (window.env.SENTRY_DSN) import('#app/utils/monitoring.client.js').then(({ init }) => init()).catch(console.error)

startTransition(() => {
	hydrateRoot(document, <RemixBrowser />)
})
